<div class="login-container">
  <div class="login-background">
    <!-- Background decorative elements -->
    <div class="bg-circle circle-1"></div>
    <div class="bg-circle circle-2"></div>
    <div class="bg-circle circle-3"></div>
  </div>

  <div class="login-content">
    <!-- Logo section -->
    <div class="logo-section">
      <img src="logo.png" alt="Babylon Financial Group Logo" class="logo-image">
      <div class="logo-text">
        <h1 class="company-name">Babylon Financial Group Zrt.</h1>
        <p class="system-name">CRM rendszer</p>
      </div>
    </div>

    <!-- Login card -->
    <mat-card class="login-card">
      <mat-card-content class="login-card-content">
        <div class="login-header">
          <h2>
            Bejelentkezés
            @if (environmentName.includes('Dev')) {
              <span class="dev-badge">DEV</span>
            }
          </h2>
        </div>

        <form class="login-form" (ngSubmit)="onLogin()">
          <!-- Username field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Felhasználónév *</mat-label>
            <input 
              matInput 
              type="text" 
              [(ngModel)]="username" 
              name="username"
              autocomplete="username">
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <!-- Password field -->
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Jelszó *</mat-label>
            <input 
              matInput 
              [type]="hidePassword ? 'password' : 'text'" 
              [(ngModel)]="password" 
              name="password"
              autocomplete="current-password">
            <mat-icon matPrefix>lock</mat-icon>
            <button 
              mat-icon-button 
              matSuffix 
              type="button"
              (click)="hidePassword = !hidePassword"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hidePassword">
              <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>

          <!-- Error message -->
          @if (errorMessage) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              {{ errorMessage }}
            </div>
          }

          <!-- Login button -->
          <button 
            mat-raised-button 
            color="primary" 
            type="submit"
            class="login-button"
            [disabled]="!username || !password">
            <mat-icon>login</mat-icon>
            Bejelentkezés
          </button>
        </form>

      </mat-card-content>
    </mat-card>
  </div>
</div>
